import { render, staticRenderFns } from "./RegisterToEvent.vue?vue&type=template&id=15156656&"
import script from "./RegisterToEvent.vue?vue&type=script&lang=js&"
export * from "./RegisterToEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports